import { useCallback as e, useMemo as t, useRef as n } from "react";
import { useHistory as r, useLocation as i } from "react-router-dom";
//#region src/hooks/useURLQuery.ts
function a(e, t) {
	if (e != null) switch (t) {
		case "string": return typeof e == "string" ? e : e[0] ?? "";
		case "number": {
			let t = Number(typeof e == "string" ? e : e[0]);
			return Number.isNaN(t) ? void 0 : t;
		}
		case "string[]": return Array.isArray(e) ? e : [e];
		case "number[]": return (Array.isArray(e) ? e : [e]).map(Number).filter((e) => !Number.isNaN(e));
		default: return e;
	}
}
function o(e, t) {
	if (e == null || e === "") return [];
	switch (t) {
		case "string": return [String(e)];
		case "number": return e === 0 ? [] : [String(e)];
		case "string[]":
		case "number[]": return Array.isArray(e) && e.length > 0 ? e.map(String) : [];
		default: return [String(e)];
	}
}
function s(s) {
	let c = i(), l = r(), u = n(s);
	u.current = s;
	let d = t(() => {
		let e = new URLSearchParams(c.search), t = {};
		for (let [n, r] of Object.entries(u.current)) {
			let i = r.type === "string[]" || r.type === "number[]", o = i ? e.getAll(n) : e.get(n);
			if (i && o.length === 0) t[n] = r.defaultValue;
			else if (!i && o === null) t[n] = r.defaultValue;
			else {
				let e = a(o, r.type);
				t[n] = e === void 0 ? r.defaultValue : e;
			}
		}
		return t;
	}, [c.search]), f = n(c);
	f.current = c;
	let p = e((e) => {
		let t = new URLSearchParams(), n = u.current;
		for (let [r, i] of Object.entries(n)) o(r in e ? e[r] : void 0, i.type).forEach((e) => t.append(r, e));
		let r = t.toString();
		l.replace({
			...f.current,
			search: r ? `?${r}` : ""
		});
	}, [l]);
	return {
		params: d,
		setParam: e((e, t) => {
			p({
				...d,
				[e]: t
			});
		}, [d, p]),
		setParams: e((e) => {
			p({
				...d,
				...e
			});
		}, [d, p]),
		resetParams: e(() => {
			let e = {};
			for (let [t, n] of Object.entries(u.current)) e[t] = n.defaultValue;
			p(e);
		}, [p])
	};
}
//#endregion
export { s as useURLQuery };
